<template>  
    <div class="carousel-container">  
        <div class="carousel-wrapper" ref="carouselWrapper">  
            <div class="carousel-item" v-for="(item, index) in abilityData" :key="index">
                <img class="background-img" :src="require('@/assets/images/platform/ability/'+item.img+'.png')" alt="背景图片加载失败">
                <div class="cover">
                    <div class="title">{{item.title}}</div>
                    <div class="subtitle">{{item.subtitle}}</div>
                    <div class="content">{{item.content}}</div>
                </div>
            </div>  
        </div>  
        <div class="btn-box">
            <div @click="moveLeft()"><svg-icon @mouseenter="leftHover()" @mouseleave="removeHover()" class="arrow-icon-left disabled" icon-class="platform-ability"></svg-icon></div>
            <div @click="moveRight()"><svg-icon @mouseenter="rightHover()" @mouseleave="removeHover()"  class="arrow-icon-right" icon-class="platform-ability" ></svg-icon></div>
        </div>
    </div>  
</template>

<script >
export default {
    name: 'carousel',
    data(){
        return{
            abilityData:[
                {title:'70+',subtitle:'全城事件自发现 ',content:'每日常态飞行，自动发现70多种事件类型，自动推送相关部门单位，实现城市巡检“机器换人”',img:'ability1'},
                {title:'5-10分钟',subtitle:'全城应急快抵达',content:'全城任意位置点击，自动生成安全的避障航线，5分钟内无人机抵达现场',img:'ability2'},
                {title:'1周1更新',subtitle:'全城时空搜索',content:'全城任意位置，均可追溯每周一期的历史影像数据，为城市各部门管理赋能',img:'ability3'},
                {title:'0成本',subtitle:'全城数字孪生',content:'3D小地块拼出三维大城市，实现三维城市的高频、零成本更新，赋能数字孪生城市建设',img:'ability4'},
                {title:'0介入',subtitle:'全城自主飞行',content:'平台调度无人机场内的无人机自主飞行，涉及到无人机的起飞、飞行、降落，保障飞行安全。',img:'ability5'},
                {title:'P2P',subtitle:'全城智能协作',content:'串联设备和平台，设备间自动触发、平台自动交互，真正实现“机器与机器”之间的对话',img:'ability6'},
                {title:'1000+',subtitle:'全城智能排期',content:'每天几百架次飞行，不同重复周期、不同类型的航线错综复杂，算法自动排期，井然有序',img:'ability7'},
                {title:'100%全覆盖',subtitle:'全城航线自动规划',content:'自研核心算法生成全覆盖航线 100%全覆盖，自动避开山体、高楼、高压线等，且确保航线间不重叠、地表全覆盖、信号通视。',img:'ability8'},
                {title:'多屏监控',subtitle:'全城飞行监控',content:'对无人机监控实时画面，包括巢外监控、巢内监控、实时图传以及气象站信息',img:'ability9'},
                {title:'自动统计',subtitle:'全城发现事件统计',content:'平台支持各种维度数据的统计，巡检结果自动生成PDF报告，提供下载',img:'ability10'},
            ],
            totalOffset: 0, // 总偏移量  
            singleMove: 608, // 单个移动距离 
            screenWidth : 0 
        }
    },
    methods:{
        moveLeft(){
            if(this.totalOffset < 0){
                if(this.totalOffset + this.singleMove >= 0){
                    this.totalOffset = 0;
                    let btn = this.$el.querySelector('.arrow-icon-left');  
                    btn.classList.add('disabled');
                }
                else{
                    if(this.totalOffset ==  this.screenWidth - 3496) {
                        let btn = this.$el.querySelector('.arrow-icon-right');  
                        btn.classList.remove('disabled');
                    }
                    this.totalOffset += this.singleMove;
                }
                this.$refs.carouselWrapper.style.transform = `translateX(${this.totalOffset}px)`; 
            }
        },
        moveRight(){
            if(this.totalOffset > this.screenWidth - 3496){
                if(this.totalOffset - this.singleMove <= this.screenWidth - 3496){ //已经移到最后一步
                    this.totalOffset =  this.screenWidth - 3496; 
                    let btn = this.$el.querySelector('.arrow-icon-right');  //修改按钮属性（禁用）
                    btn.classList.add('disabled');
                }
                else{
                    if(this.totalOffset == 0){
                        let btn = this.$el.querySelector('.arrow-icon-left');  
                        btn.classList.remove('disabled');
                    }
                    this.totalOffset -= this.singleMove;
                }
                this.$refs.carouselWrapper.style.transform = `translateX(${this.totalOffset}px)`; 
            }
        },
        leftHover(){
            if(this.totalOffset < 0) {
                let btn = this.$el.querySelector('.arrow-icon-left');  
                btn.classList.add('hover');
            }
        },
        rightHover(){
            if(this.totalOffset > this.screenWidth - 3496) {
                let btn = this.$el.querySelector('.arrow-icon-right');  
                btn.classList.add('hover');
            }
        },
        removeHover(){
            let btn = this.$el.querySelector('.hover');  
            if(btn){
                btn.classList.remove('hover');
            }
        },
    },
    mounted(){
        this.screenWidth = window.innerWidth; 
    },
}

</script>

<style lang="scss" scoped>  
.carousel-container{
    width: 100%;
    height: 100%;
    overflow: hidden;

    .carousel-wrapper {  
        display: flex;  
        width: 3496px;
        transition: transform 0.5s ease;  
        will-change: transform; 
        padding: 0px 240px; 
        margin: 0;

        .carousel-item {  
            width: 280px;
            height: 420px;
            margin-right: 24px;
            position: relative;
            z-index: 1;
            overflow: hidden;
            border-radius: 8px;

            &:last-of-type{
                margin: 0;
            }

            .background-img{
                position: absolute;
                width: 280px;
                height: 420px;
                z-index: 2;
                transition: transform 0.5s ease;  
                object-fit: cover;
                object-position: center;
            }
            .cover{
                width: 100%;
                height: 188px;
                background: #000000b3;
                z-index: 3;
                position: absolute;
                bottom: 0%;
                backdrop-filter: blur(3px);
                padding:23px 32px;
                color: #FFFFFF;

                .title{
                    height: 28px;
                    font-weight: 500;
                    font-size: 22px;
                    line-height: 28px;
                    margin-top: 1px;
                    margin-bottom: 4px;
                }
                .subtitle{
                    height: 28px;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 28px;
                }
                .content{
                    height: 66px;
                    opacity: 0.85;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 22px;
                    margin-top: 10px;
                }
            }

            &:hover{
                .background-img{
                    transform: scale(1.3); 
                }
            }

        }   
    }
    .btn-box{
        display: flex;
        justify-content: center;
        margin-top: 54px;
        .arrow-icon-left{
            width: 42px;
            height: 42px;
            opacity: 0.85;
            transform: scaleX(-1);
            margin-right: 40px;
        }
        .arrow-icon-right{
            width: 42px;
            height: 42px;
            opacity: 0.85;
        }
        .disabled{
            opacity: 0.4;
        }
        .hover{
            cursor: pointer;  
            opacity: 1;
        }
    }
}
</style>